(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ys-cert-exhibition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ys-ce-carousel')) {
    customElements.define('ys-ce-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsEl = this.querySelector('[data-dots]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || !this.slides.length) return;
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.speed = Math.max(2000, Number(this.dataset.speed) || 4000);
        this.querySelector('[data-prev]')?.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        this.querySelector('[data-next]')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => { const i = this.nearest(); if (i !== this.index) { this.index = i; this.sync(); } }, 90);
        }, { passive: true });
        ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => { this.hold = true; this.stop(); }, { passive: true }));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => { this.hold = false; this.start(); }));
        this.addEventListener('touchend', () => { clearTimeout(this.resumeT); this.resumeT = setTimeout(() => { this.hold = false; this.start(); }, this.speed); }, { passive: true });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.addEventListener('shopify:block:select', (e) => { const i = this.slides.findIndex((s) => s.contains(e.target)); if (i > -1) { this.stop(); this.hold = true; this.go(Math.min(i, this.max())); } });
        this.addEventListener('shopify:block:deselect', () => { this.hold = false; this.start(); });
        this.ro = new ResizeObserver(() => this.layout());
        this.ro.observe(this.track);
        this.io = new IntersectionObserver((en) => { this.visible = en[0].isIntersecting; this.visible ? this.start() : this.stop(); });
        this.io.observe(this);
        this.layout();
      }
      disconnectedCallback() { this.stop(); this.ro?.disconnect(); this.io?.disconnect(); }
      offset(i) { const s = this.slides[i], f = this.slides[0]; return s && f ? s.offsetLeft - f.offsetLeft : 0; }
      limit() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      /* last index whose start can still be scrolled to (the rest are already visible at the end) */
      max() { const l = this.limit(); for (let i = 0; i < this.slides.length; i++) { if (this.offset(i) >= l - 2) return i; } return this.slides.length - 1; }
      nearest() {
        const x = this.track.scrollLeft; if (x >= this.limit() - 2) return this.max();
        let best = 0, d = Infinity; this.slides.forEach((s, i) => { const dd = Math.abs(this.offset(i) - x); if (dd < d) { d = dd; best = i; } }); return Math.min(best, this.max());
      }
      layout() {
        const m = this.max();
        this.classList.toggle('is-static', m < 1);
        if (this.dotsEl && this.dotsEl.children.length !== m + 1) {
          this.dotsEl.innerHTML = '';
          for (let i = 0; i <= m; i++) {
            const b = document.createElement('button');
            b.type = 'button'; b.className = 'ys-ce__dot'; b.setAttribute('aria-label', (i + 1) + ' / ' + (m + 1));
            b.addEventListener('click', () => { this.go(i); this.restart(); });
            this.dotsEl.appendChild(b);
          }
        }
        if (this.index > m) this.index = m;
        this.sync();
      }
      go(i) {
        const m = this.max();
        if (i > m) i = 0; else if (i < 0) i = m;           // loop
        this.index = i;
        this.track.scrollTo({ left: Math.min(this.offset(i), this.limit()), behavior: this.reduced ? 'auto' : 'smooth' });
        this.sync();
      }
      sync() { Array.from(this.dotsEl?.children || []).forEach((d, i) => { const on = i === this.index; d.classList.toggle('is-active', on); d.setAttribute('aria-current', on ? 'true' : 'false'); }); }
      start() { if (!this.autoplay || this.hold || this.timer || this.max() < 1 || this.visible === false) return; this.timer = setInterval(() => this.go(this.index + 1), this.speed); }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-expert-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ys-video')) {
    customElements.define('ys-video', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('button.ys-expert__play');
        const tpl = this.querySelector('template');
        if (!btn || !tpl) return;
        btn.addEventListener('click', () => {
          const node = tpl.content.firstElementChild.cloneNode(true);
          this.innerHTML = '';
          this.appendChild(node);
          this.classList.add('is-playing');
          if (node.tagName === 'VIDEO') node.play && node.play().catch(() => {});
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ys-hero-slider')) {
    customElements.define('ys-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('[data-prev]')?.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        this.querySelector('[data-next]')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((d) => d.addEventListener('click', () => { this.go(Number(d.dataset.dot)); this.restart(); }));
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) { this.index = i; this.sync(); }
          }, 80);
        }, { passive: true });
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.speed = Math.max(3000, Number(this.dataset.speed) || 5000);
        ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => this.stop(), { passive: true }));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.addEventListener('shopify:block:select', (e) => { const i = this.slides.indexOf(e.target); if (i > -1) { this.stop(); this.go(i); } });
        this.addEventListener('shopify:block:deselect', () => this.start());
        this.sync();
        this.start();
        // Speed: after page load only the next slide is fetched; as soon as the visitor interacts with the slider all slides are fetched.
        const warm = () => { this.ready = true; this.sync(); };
        const engage = () => { this.ready = true; this.slides.forEach((_, i) => this.hydrate(i)); };
        const idle = window.requestIdleCallback || ((f) => setTimeout(f, 200));
        if (document.readyState === 'complete') idle(warm); else window.addEventListener('load', () => idle(warm), { once: true });
        ['mouseenter', 'touchstart', 'pointerdown', 'keydown', 'focusin'].forEach((e) => this.addEventListener(e, engage, { once: true, passive: true }));
      }
      hydrate(i) {
        const n = this.slides.length, s = this.slides[((i % n) + n) % n];
        if (!s || s.dataset.ysHydrated) return;
        s.dataset.ysHydrated = '1';
        s.querySelectorAll('[data-ys-srcset]').forEach((el) => { el.setAttribute('srcset', el.getAttribute('data-ys-srcset')); el.removeAttribute('data-ys-srcset'); });
        s.querySelectorAll('[data-ys-src]').forEach((el) => { el.setAttribute('src', el.getAttribute('data-ys-src')); el.removeAttribute('data-ys-src'); });
      }
      disconnectedCallback() { this.stop(); }
      go(i) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduced ? 'auto' : 'smooth' });
        this.sync();
      }
      sync() {
        this.hydrate(this.index);
        if (this.ready) this.hydrate(this.index + 1);
        this.dots.forEach((d, i) => { const on = i === this.index; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); });
        this.slides.forEach((s, i) => { if (i === this.index) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      }
      start() { if (!this.autoplay || this.timer) return; this.timer = setInterval(() => this.go(this.index + 1), this.speed); }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  /* Shared by ys-promo-ticker + ys-logo-marquee: same px/s for every marquee, duration = one loop width / speed. */
  if (!window.ysMarqueeSync) {
    window.ysMarqueeSync = (function () {
      const set = (sec) => {
        const track = sec.querySelector('[data-ys-marquee-track]');
        const pxs = parseFloat(sec.dataset.ysPxs) || 50;
        if (!track || !track.offsetWidth) return;
        sec.style.setProperty('--ys-speed', (track.offsetWidth / pxs).toFixed(2) + 's');
      };
      const ro = 'ResizeObserver' in window ? new ResizeObserver((en) => en.forEach((e) => { const s = e.target.closest('[data-ys-pxs]'); if (s) set(s); })) : null;
      const init = (root) => (root || document).querySelectorAll('[data-ys-pxs]').forEach((sec) => {
        set(sec);
        if (ro && !sec._ysObs) { sec._ysObs = true; const t = sec.querySelector('[data-ys-marquee-track]'); if (t) ro.observe(t); }
      });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
      window.addEventListener('load', () => init());
      window.addEventListener('resize', () => init());
      document.addEventListener('shopify:section:load', (e) => init(e.target));
      return { init };
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-promo-ticker"] && !Shopify.designMode) return;
  try {
    
  /* Shared by ys-promo-ticker + ys-logo-marquee: same px/s for every marquee, duration = one loop width / speed. */
  if (!window.ysMarqueeSync) {
    window.ysMarqueeSync = (function () {
      const set = (sec) => {
        const track = sec.querySelector('[data-ys-marquee-track]');
        const pxs = parseFloat(sec.dataset.ysPxs) || 50;
        if (!track || !track.offsetWidth) return;
        sec.style.setProperty('--ys-speed', (track.offsetWidth / pxs).toFixed(2) + 's');
      };
      const ro = 'ResizeObserver' in window ? new ResizeObserver((en) => en.forEach((e) => { const s = e.target.closest('[data-ys-pxs]'); if (s) set(s); })) : null;
      const init = (root) => (root || document).querySelectorAll('[data-ys-pxs]').forEach((sec) => {
        set(sec);
        if (ro && !sec._ysObs) { sec._ysObs = true; const t = sec.querySelector('[data-ys-marquee-track]'); if (t) ro.observe(t); }
      });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
      window.addEventListener('load', () => init());
      window.addEventListener('resize', () => init());
      document.addEventListener('shopify:section:load', (e) => init(e.target));
      return { init };
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-qa-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ys-qa-drawer')) {
    customElements.define('ys-qa-drawer', class extends HTMLElement {
      connectedCallback() {
        this.tab = this.querySelector('[data-qa-open]');
        this.panel = this.querySelector('.ys-qa__panel');
        this.overlay = this.querySelector('.ys-qa__overlay');
        this.backBtn = this.querySelector('[data-qa-back]');
        this.search = this.querySelector('[data-qa-search]');
        this.list = this.querySelector('[data-qa-list]');
        this.status = this.querySelector('[data-qa-status]');
        this.empty = this.querySelector('[data-qa-empty]');
        this.body = this.querySelector('[data-qa-body]');
        this.contactBtn = this.querySelector('[data-qa-contact]');
        this.view = 'list';
        this.tab.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-qa-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.backBtn.addEventListener('click', () => this.show('list'));
        this.contactBtn.addEventListener('click', () => this.show(this.view === 'contact' ? 'list' : 'contact'));
        this.querySelectorAll('[data-qa-ask]').forEach((b) => b.addEventListener('click', () => this.ask()));
        this.search.addEventListener('input', () => { if (this.view !== 'list') this.show('list', true); this.filter(); });
        this.panel.addEventListener('keydown', (e) => this.onKey(e));
        this.addEventListener('shopify:section:select', () => this.open());
        this.addEventListener('shopify:section:deselect', () => this.close());
        const idle = window.requestIdleCallback || ((f) => setTimeout(f, 2500));
        idle(() => this.load());
      }
      focusables() {
        return Array.from(this.panel.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])')).filter((el) => !el.closest('[hidden]') && !el.disabled && el.offsetParent !== null);
      }
      onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); if (this.view !== 'list') this.show('list'); else this.close(); return; }
        if (e.key !== 'Tab') return;
        const f = this.focusables(); if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      open() {
        if (this.classList.contains('is-open')) return;
        this.lastFocus = document.activeElement;
        const chat = document.querySelector('shopify-chat');
        if (chat) { try { if (chat.open) chat.open = false; } catch (e) {} }
        this.overlay.hidden = false; this.panel.hidden = false;
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
        document.documentElement.classList.add('ys-qa-lock');
        this.tab.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
        this.load();
        setTimeout(() => { (window.matchMedia('(min-width: 750px)').matches ? this.search : this.panel.querySelector('.ys-qa__close')).focus({ preventScroll: true }); }, 60);
      }
      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.tab.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('ys-qa-lock');
        document.body.style.paddingRight = '';
        const done = () => { if (!this.classList.contains('is-open')) { this.panel.hidden = true; this.overlay.hidden = true; } };
        setTimeout(done, 320);
        (this.lastFocus && this.lastFocus.focus ? this.lastFocus : this.tab).focus({ preventScroll: true });
      }
      show(view, keepFocus) {
        this.view = view;
        this.querySelectorAll('[data-qa-view]').forEach((v) => { v.hidden = v.dataset.qaView !== view; });
        this.backBtn.hidden = view === 'list';
        this.contactBtn.setAttribute('aria-pressed', view === 'contact' ? 'true' : 'false');
        this.body.scrollTop = 0;
        if (keepFocus) return;
        if (view === 'list') { (this.lastQ && this.lastQ.isConnected ? this.lastQ : this.search).focus({ preventScroll: false }); }
        else { const t = this.querySelector('[data-qa-view="' + view + '"] .ys-qa__a-title'); if (t) t.focus({ preventScroll: true }); }
      }
      ask() {
        const chat = document.querySelector('shopify-chat');
        if (chat && window.customElements && customElements.get('shopify-chat')) {
          this.close();
          try { chat.open = true; } catch (e) {}
          setTimeout(() => {
            try {
              if (chat.open === true) return;
              const rt = chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
              const btn = rt && rt.shadowRoot && rt.shadowRoot.querySelector('[part="activator"]');
              if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
            } catch (e) {}
          }, 500);
          return;
        }
        window.location.href = this.dataset.askUrl || '/pages/contact-us#inquiry';
      }
      async load() {
        if (this.loaded || this.loading) return;
        this.loading = true;
        const key = 'ys_qa_cache_v2';
        let html = null;
        try { html = sessionStorage.getItem(key); } catch (e) {}
        if (!html) {
          try {
            const res = await fetch(this.dataset.faqUrl, { credentials: 'same-origin' });
            if (res.ok) {
              const d = new DOMParser().parseFromString(await res.text(), 'text/html');
              const main = d.querySelector('.ys-pfaq__main');
              if (main) { html = main.outerHTML; try { sessionStorage.setItem(key, html); } catch (e) {} }
            }
          } catch (e) {}
        }
        this.loading = false;
        if (!html) { this.status.innerHTML = '<a href="' + this.dataset.faqUrl + '">' + this.status.textContent.replace(/\u2026|\.\.\./g, '') + '</a>'; return; }
        this.build(html);
      }
      build(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.items = [];
        const frag = document.createDocumentFragment();
        doc.querySelectorAll('.ys-pfaq__group').forEach((g) => {
          const qs = g.querySelectorAll('.ys-pfaq__item');
          if (!qs.length) return;
          const wrap = document.createElement('div'); wrap.className = 'ys-qa__group';
          const t = g.querySelector('.ys-pfaq__group-title');
          if (t) { const h = document.createElement('h3'); h.className = 'ys-qa__cat'; h.textContent = t.textContent.trim(); wrap.appendChild(h); }
          const ul = document.createElement('ul'); ul.className = 'ys-qa__qs'; ul.setAttribute('role', 'list');
          qs.forEach((d) => {
            const q = d.querySelector('.ys-pfaq__q-text'), a = d.querySelector('.ys-pfaq__a-text');
            if (!q) return;
            const li = document.createElement('li');
            const b = document.createElement('button'); b.type = 'button'; b.className = 'ys-qa__q'; b.textContent = q.textContent.trim();
            const item = { q: b.textContent, a: a ? a.innerHTML : '', text: (b.textContent + ' ' + (a ? a.textContent : '')).toLowerCase(), li, wrap };
            b.addEventListener('click', () => this.answer(item, b));
            li.appendChild(b); ul.appendChild(li); this.items.push(item);
          });
          wrap.appendChild(ul); frag.appendChild(wrap);
        });
        if (!this.items.length) { this.status.textContent = ''; this.empty.hidden = false; return; }
        this.list.appendChild(frag);
        this.status.hidden = true;
        this.loaded = true;
        this.filter();
      }
      filter() {
        if (!this.items) return;
        const terms = this.search.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
        let any = 0;
        const groups = new Map();
        this.items.forEach((it) => {
          const ok = terms.every((t) => it.text.includes(t));
          it.li.hidden = !ok; if (ok) any++;
          groups.set(it.wrap, (groups.get(it.wrap) || 0) + (ok ? 1 : 0));
        });
        groups.forEach((n, w) => { w.hidden = n === 0; });
        this.empty.hidden = any > 0;
      }
      answer(item, btn) {
        this.lastQ = btn;
        this.querySelector('[data-qa-a-title]').textContent = item.q;
        this.querySelector('[data-qa-a-text]').innerHTML = item.a;
        this.show('answer');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
